export default __webpack_public_path__ + "static/media/agentBottom.ab21d670.gif";